import { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { snowplowInitializedAtom } from 'lib/atoms/snowplowInitialized';

function useInitializeSnowPlow(): void {
  const setSnowplowInitialized = useSetAtom(snowplowInitializedAtom);

  useEffect(() => {
    // If we're on the server, don't initialize Snowplow
    if (typeof window === 'undefined') return;

    try {
      snowplow('newTracker', 'atrck', 'sp.autolist.com', {
        appId: 'autolist web',
        discoverRootDomain: true,
        forceSecureTracker: true,
        eventMethod: 'get',
        contexts: {
          webPage: true,
          performanceTiming: true,
          gaCookies: true,
        },
      });
      snowplow('setUserIdFromCookie', 'client_guid_timestamp');
      snowplow('enableActivityTracking', 5, 5);
      snowplow('trackPageView');
      snowplow('enableLinkClickTracking');
      snowplow('enableFormTracking');

      setSnowplowInitialized(true);
    } catch (error) {
      console.error('[Snowplow] Initialization failed', { error });
    }
  }, [setSnowplowInitialized]);
}

export default useInitializeSnowPlow;
